export const ADD_PAYMENT_METHOD_OR_RELOAD = 'addPaymentMethodOrReload';
export const ADD_NEW_GIFT_CARD_TRANSLATION_ID = 'addNewPaymentMethodGiftCard';
